var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("TopNavigation", { attrs: { "top-act": "5" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "pan110" },
        [
          _c("listTopImg", { attrs: { imgType: "4" } }),
          _c(
            "div",
            { staticClass: "marginAuto" },
            [
              this.$store.state.webNavigator == "phone"
                ? _c("div", { staticClass: "brandInfo-tlt" }, [
                    _vm._v("\n        - 品牌资讯 -\n      ")
                  ])
                : _vm._e(),
              _c("articlePage", {
                key: _vm.keys,
                attrs: {
                  listType: _vm.informationType,
                  titles: "品牌资讯",
                  classType: "A5",
                  active: _vm.types,
                  pageIndex: _vm.current,
                  toLeveListPath: _vm.toLeveListPath
                },
                on: { getTotal: _vm.getTotal }
              }),
              _c("Pagination", {
                key: _vm.pageKey,
                attrs: {
                  total: _vm.total,
                  display: 12,
                  currentPage: _vm.current
                },
                on: { pagechange: _vm.getPage }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ba6380a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba6380a","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/brandInfo/brandInfo.vue
// module id = 1141
// module chunks = 4